<template>
  <el-scrollbar>
    <el-row :gutter="10">
      <el-col :span="12">
        <el-form-item label="卷宗附件最大限制">
          <el-input v-model="data_.penalize_limit_max_size">
            <template #append>M</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="卷宗附件文件类型限制">
          <el-input v-model="data_.penalize_accept">
            <template #append>多个已逗号隔开</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="行业类型排污许可必填限制">
          <el-input v-model="data_.penalize_emission_limits" :rows="5" :maxlength="5000" placeholder="多个已逗号隔开" show-word-limit type="textarea">
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="执法人员填写模型">
          <el-switch
            v-model="data_.penalize_select_person_mode"
            active-text="选择填写"
            inactive-text="手工填写"
            active-value="true"
            inactive-value="false"
          ></el-switch>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="填报表单模式">
          <el-switch
            v-model="data_.penalize_select_fill_mode"
            active-text="平铺"
            inactive-text="步骤"
            active-value="true"
            inactive-value="false"
          ></el-switch>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="禁止下载卷宗附件材料人员">
          <td-user-select v-model="data_.DISABLED_DOWNLOAD_FOLDER_ATTACH_USER" org-type="all" openSearch></td-user-select>
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item label="人员头像下显示单位信息角色" prop="PENALIZE_SHOW_ORG_ROLE">
          <td-select-tree
            v-model="data_.PENALIZE_SHOW_ORG_ROLE"
            :action="tree"
            multiple
            checkStrictly
            :prop="{
              key: 'id',
              label: 'title',
              children: 'children'
            }"
          ></td-select-tree>
        </el-form-item>
      </el-col>
      <el-col>
        <el-form-item label="忽略校验的社会信用代码" prop="socialCreditCode_ignore">
          <el-input v-model="data.socialCreditCode_ignore" show-word-limit type="textarea" :rows="5" :maxlength="5000" placeholder="多个已逗号隔开">
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-scrollbar>
</template>
<script setup>
import { computed } from 'vue'
const props = defineProps({
  data: {
    type: Object,
    default: () => {}
  }
})
const emit = defineEmits(['update:data'])
const data_ = computed({
  get() {
    return props.data
  },
  set(val) {
    emit('update:data', val)
  }
})
const { tree } = TdUI.api.admin.role
</script>
<script>
export default {
  name: 'ConfigPenalize',
  cname: '行政处罚填报',
  icon: 'iconfont  ui-amy-calculator'
}
</script>
